<template>
  <textarea id="rfConfigRaw" v-model="config" name="rfConfig" class="form-control" @keyup="propsChanged=false" />
</template>

<script>
export default {
  model: {
    prop: 'rfConfig',
    event: 'change'
  },

  props: {
    rfConfig: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      // Trigger change event only when it's not the props that has changed
      propsChanged: false,

      config: ''
    }
  },

  watch: {
    rfConfig () {
      // Pretty print JSON
      this.config = JSON.stringify(JSON.parse(this.rfConfig), null, 4)
      this.propsChanged = true
    },

    config (newValues, oldValues) {
      // Check old formDataProvider is empty to not validateForm
      const isOldValuesEmpty = !oldValues

      // Only detect changes when there were some values before change
      if (!isOldValuesEmpty && !this.propsChanged) {
        // Update v-model
        this.$emit('change', this.config)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  textarea.form-control {
    width: 100%;
    height: 50vh;
    font-family: monospace;
  }
</style>
